import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    ChartDataLabels
);

const BarChart = ({ title, values }) => {
    const [solved, notSolved] = values;

    const data = {
        labels: ['Решённые', 'Нерешённые'],
        datasets: [
            {
                label: title,
                data: [solved, notSolved],
                backgroundColor: ['blue', 'red'],
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: true,
                text: title,
                font: {size: 18, weight: 'bold'},
            },
            datalabels: {
                anchor: 'end',
                align: 'start',
                color: 'white',
                font: {
                    weight: 'bold',
                    size: 14,
                },
                formatter: Math.round,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 1,
                    precision: 0,
                    callback: (value) => (Number.isInteger(value) ? value : null),
                },
            },
        },
    };

    return <Bar data={data} options={options} plugins={[ChartDataLabels]} />;
};

export default BarChart;
